import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import ImageText3 from "../components/ImageText3";
import RichText from "../components/RichText";

import video from "../assets/videos/dsg1.mp4";
import imageurl1 from "../assets/images/dsg1.png";
import imageurl2 from "../assets/images/dsg2.png";
import video2 from "../assets/videos/service2.mp4";

function DSGTuning() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Er bestaan verschillende soorten automaten o.a. TCT-automaat,
        CVT-automaat (Continuously Variable Transmission), ETG-automaat
        (Robotbak) en nog meer. Een populaire soort is een DSG-automaat. DSG
        staat voor Direct Shift Gearbox, ook wel de automaat met een dubbele
        koppeling genoemd, oftewel het heeft twee automatische
        versnellingsbakken. De één staat voor de oneven versnellingen en de
        ander staat voor de even versnellingen. De versnellingsbak zet de
        volgende versnelling al klaar als er in een bepaalde versnelling wordt
        gereden.
      </p>
      <br />
      <p className="text-white text-lg">
        Bijna alle voertuigen die voorzien zijn van een automaat komen in
        aanmerking voor tuning, wilt u weten wat wij voor uw auto kunnen
        betekenen? Neem dan contact met ons op.
      </p>
    </>
  );

  const text2 = (
    <>
      <p className="text-white text-lg">
        Bij DSG/ Automaat tuning (Direct Shift Gearbox tuning) worden de
        software-instellingen van de automatische versnellingsbak aangepast om
        de prestaties te verbeteren. Dit kan verschillende voordelen opleveren,
        zoals:
      </p>
      <br />
      <ol className="list-decimal">
        <li>
          Snellere schakel overgangen: De timing van de overschakelingen wordt
          verbeterd, wat resulteert in snellere en soepelere schakelmomenten.
        </li>
        <li>
          Verhoogd koppel: De DSG-tuning kan het koppel dat de transmissie
          aankan verhogen, wat betere acceleratie mogelijk maakt.
        </li>
        <li>
          Betere respons: De algehele respons van de versnellingsbak kan worden
          verbeterd, waardoor het voertuig sneller reageert op gasgeven en
          remmen.
        </li>
        <li>
          Sportieve rijmodus: De tuning kan ook zorgen voor een meer sportieve
          rijervaring door de instellingen aan te passen voor een agressieve
          schakelstrategie.
        </li>
      </ol>
      <br />
      <p className="text-white text-lg">
        Het resultaat is vaak een voelbare verbetering in de rijprestaties en
        een sportievere rijervaring. Houderechter rekening mee dat niet alle
        voertuigen geschikt zijn voor DSG-tuning.
      </p>
    </>
  );

  const text3 = (
    <>
      <h3 className="text-[#BD0E0E] text-xl">LET OP!</h3>
      <br />
      <p className="text-white text-lg">
        Hetkanvoorkomendatdeservice DSGTUNINGwordtaangeradenbij het afnemen van
        deservice Chiptuning, dit kan te maken hebben met dat de versnellingsbak
        extra koppel moetkunnenverwerken.
      </p>
      <br />
      <p className="text-white text-lg">
        Heeft u vragen over deze service of wilt u weten of uw voertuig hiervoor
        in aanmerking komt?
      </p>
      <br />
      <h3 className="text-[#BD0E0E] text-xl">Neemdancontactmetonsop</h3>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="DSG / AUTOMAAT TUNING" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText3
        text={text2}
        imageUrl={imageurl2}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <RichText text={text3} />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default DSGTuning;
